module.exports = __webpack_public_path__ + "static/media/_antd.97f1bb68.less";


//////////////////
// WEBPACK FOOTER
// ./src/resources/_antd.less
// module id = 1341
// module chunks = 0